module.exports = __webpack_public_path__ + "img/logo_text_black_140_32.d647a1ff.svg";